export class FiltersBar extends HTMLElement {
  get form() {
    return this.querySelector<HTMLFormElement>("form");
  }

  connectedCallback() {

    const inputs = this.querySelectorAll("input");
    const selects = this.querySelectorAll("select");
    
    this.querySelector("button[data-filters")?.addEventListener(
      "click",
      this._onClickFilters
    );
    const elements = [...inputs, ...selects];

    for (const element of elements) {
      element.addEventListener("change", (e) => {
        this.form.submit();
      });
    }
  }

  _onClickFilters = () => {
    this.dispatchEvent(
      new CustomEvent("open-filters", {
        bubbles: true,
      })
    );
  };


}

customElements.define('ac101-filters-bar', FiltersBar);

declare global {
  interface HTMLElementTagNameMap {
    "ac101-filters-bar": FiltersBar;
  }
}
